import * as ko from "knockout";

import * as pliObservable from "../forms-knockoutcontrols";
import { TextBoxObservable } from "../forms-knockoutcontrols/pliTextBoxObservable";


/**
 * Pli observable extended with "hasFocus" observable.
 * Allows single viewmodel property to track both value and input focus.
 */
export interface TextBoxObservableWithFocus<T> extends ko.Observable<T>, TextBoxObservable<T> {
    hasFocus: ko.Observable<boolean>;
}


/**
 * Create new instance of "TextBoxObservableWithFocus".
 */
export function createTextBoxObservableWithFocus<T>(initialValue: T, behaviourData?: any, behaviour?: any): TextBoxObservableWithFocus<T> {
    const o = pliObservable(initialValue, behaviourData, behaviour) as TextBoxObservableWithFocus<T>;
    o.hasFocus = ko.observable(false);
    return o;
}


/**
 * Pli observable extended with "hasFocus" and "visible" observables.
 * Allows single viewmodel property to track value, focus and visibility.
 */
export interface TextBoxObservableWithFocusAndVisibility<T> extends TextBoxObservableWithFocus<T> {
    visible: ko.Observable<boolean>;
}


/**
 * Create new instance of "TextBoxObservableWithFocusAndVisibility".
 */
export function createTextBoxObservableWithFocusAndVisibility<T>(initialValue: T, behaviourData?: any, behaviour?: any): TextBoxObservableWithFocusAndVisibility<T> {
    const o = createTextBoxObservableWithFocus(initialValue, behaviourData, behaviour) as TextBoxObservableWithFocusAndVisibility<T>;
    o.visible = ko.observable(false);
    return o;
}


/**
 * List of supported sign-in pages.
 *
 * A page is a well-defined area of user-facing functionality (e.g. main page
 * with username + password, forgotten username/password page with email, etc).
 * One page can transition to any other page (using animation).
 */
export enum SignInPageId {
    None,          // 0
    Main,          // 1
    Forgot,        // 2
    LockedOut,     // 3
    ChangePassword // 4
}


/**
 * Describes an owner/manager of sign-in pages.
 */
export interface SignInPagesCollection {
    /**
     * Get viewmodel for the specified page.
     */
    getPage<TPage>(pageId: SignInPageId, skipCreation?: boolean): TPage;

    /**
     * Tracks currently selected page.
     */
    currentPageId: ko.Observable<SignInPageId>;
}


/**
 * Empty object (useful as a fallback for server data stored in observables).
 * When used as a default observable value, setting it multiple times
 * will not notify subscribers (because of reference equality), unlike when
 * empty object literal is used, e.g. "response.result || {}".
 */
export const emptyData: Object = {};



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/forms-signin/signInShared.ts